function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classNames from "classnames";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withAbTests } from "contexts/ab-tests-context";
import { preventFocusOnMouseDown, setSVGTitle } from "client/services/accessibility/accessibility-service";
import { trackEvent } from "services/bigbrain-service";
import PricingInfoIcon from "/static/svg/pricing-info-icon.svg";
import TooltipComponent from "components/enhancements/tooltip/tooltip-component";
import { DARK_THEME } from "components/enhancements/tooltip/tooltip-constants";
import { PRICING_PAGE_FEATURE_LINK_CLICKED } from "constants/bigbrain-event-types";
import { HP_SOURCE, PRICING_PAGE_FEATURE_INFO_ICON_HOVER, PRICING_PAGE_FEATURE_INFO_ICON_EXIT } from "/constants/bigbrain-event-types";
import { StyledFeatureInfoWithTooltip } from "./feature-info-with-tooltip.scss";
class FeatureInfoWithTooltip extends PureComponent {
    componentDidMount() {
        const { feature, translateOrTranslateWithParam } = this.props;
        const { text } = feature;
        setSVGTitle(`#${this.getContainerID()}`, translateOrTranslateWithParam(text));
    }
    render() {
        const { feature, featureInfoClassname, translateOrTranslateWithParam } = this.props;
        const { tooltipActive } = this.state;
        return /*#__PURE__*/ _jsxs(StyledFeatureInfoWithTooltip, {
            className: classNames(`feature-info ${featureInfoClassname}`, {
                "tooltip-active": tooltipActive
            }),
            onMouseEnter: this.onMouseEnterInfoIcon,
            onMouseLeave: this.onMouseLeaveInfoIcon,
            tabIndex: 0,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onMouseDown: preventFocusOnMouseDown,
            "aria-label": translateOrTranslateWithParam(feature.text),
            id: this.getContainerID(),
            children: [
                this.renderInfoIcon(),
                /*#__PURE__*/ _jsx("div", {
                    className: "feature-tooltip-container",
                    children: /*#__PURE__*/ _jsx(TooltipComponent, {
                        theme: DARK_THEME,
                        className: classNames("floating-tooltip"),
                        children: translateOrTranslateWithParam(feature.text)
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "getContainerID", ()=>{
            const { index, tier, isMobile } = this.props;
            return `featureInfo_${tier}_${index}${isMobile ? "_mobile" : ""}`;
        });
        _define_property(this, "onMouseEnterInfoIcon", ()=>{
            const { feature, placement, translateOrTranslateWithParam, tier } = this.props;
            const { name } = feature;
            BigBrain("track", PRICING_PAGE_FEATURE_INFO_ICON_HOVER, {
                placement,
                source: HP_SOURCE,
                kind: name,
                info1: translateOrTranslateWithParam(name),
                info2: tier
            });
        });
        _define_property(this, "onMouseLeaveInfoIcon", ()=>{
            const { feature, placement, translateOrTranslateWithParam, tier } = this.props;
            const { name } = feature;
            BigBrain("track", PRICING_PAGE_FEATURE_INFO_ICON_EXIT, {
                placement,
                source: HP_SOURCE,
                kind: name,
                info1: translateOrTranslateWithParam(name),
                info2: tier
            });
        });
        _define_property(this, "onFocus", ()=>{
            this.onMouseEnterInfoIcon();
            this.setState({
                tooltipActive: true
            });
        });
        _define_property(this, "onBlur", ()=>{
            this.onMouseLeaveInfoIcon();
            this.setState({
                tooltipActive: false
            });
        });
        _define_property(this, "onFeatureLinkClick", (event)=>{
            event.preventDefault();
            const { feature, tier } = this.props;
            const { name, link } = feature;
            trackEvent(PRICING_PAGE_FEATURE_LINK_CLICKED, {
                kind: link,
                info1: name,
                info2: tier
            });
            window.open(link, "_blank", "noopener,noreferrer");
        });
        _define_property(this, "renderInfoIcon", ()=>{
            const { feature } = this.props;
            const { link } = feature;
            if (!link) {
                return /*#__PURE__*/ _jsx(PricingInfoIcon, {});
            }
            return /*#__PURE__*/ _jsx("a", {
                tabIndex: 0,
                href: link,
                onClick: this.onFeatureLinkClick,
                children: /*#__PURE__*/ _jsx(PricingInfoIcon, {})
            });
        });
        this.state = {
            tooltipActive: false
        };
    }
}
export default withAbTests(withGenericConfig(FeatureInfoWithTooltip));
FeatureInfoWithTooltip.defaultProps = {
    placement: "price-and-features-card",
    featureInfoClassname: ""
};
